import { Component, OnInit } from '@angular/core';
import { DopMenuService } from 'projects/dop-menu/src/lib/dop-menu.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
})
export class LogoutComponent implements OnInit {


  constructor(
    private menuService: DopMenuService) { }

  ngOnInit(): void {
    this.menuService.logout();
  }

}
